import React, { Component, useState } from 'react';
export const Loggedincontext = React.createContext();

export const Loggedincontext_provider = (props) => {
    const [isloggedincontext, setisloggedincontext] = useState(false);
    const [instbranchescontext, setinstbranchescontext] = useState([]);
    const [useraccesspagescontext, setuseraccesspagescontext] = useState([]);
    const [surveyModalOpenContext, setsurveyModalOpenContext] = useState(false);

    const [userloggedinfobjcontext, setuserloggedinfobjcontext] = useState({
        userinfo: {
            name: '',
            email: '',
            mobile: '',
            type: '',
            useractive: '',
            currentinstactive: '',
        },
        currentinstinfo: {
            instname: '',
            instlogo: '',
            instsubdomain: '',
            subscriptiondetails: {},
        },
    });

    return (
        <Loggedincontext.Provider
            value={{
                isloggedincontext,
                setisloggedincontext,
                userloggedinfobjcontext,
                setuserloggedinfobjcontext,
                instbranchescontext,
                setinstbranchescontext,
                useraccesspagescontext,
                setuseraccesspagescontext,
                surveyModalOpenContext,
                setsurveyModalOpenContext,
            }}
        >
            {props.children}
        </Loggedincontext.Provider>
    );
};

export const Loggedincontext_consumer = Loggedincontext.Consumer;
